export default "__VITE_ASSET__a993f716__"